exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1FgAl-7_3_0 {\n  display: inline-flex; }\n  .QtZLT-7_3_0 {\n    cursor: pointer; }\n  ._3Hw5E-7_3_0 {\n    transition: color 0.2s ease-in-out; }\n    ._3Hw5E-7_3_0:hover {\n      color: #000000; }\n  ._2g2N0-7_3_0:hover {\n    color: #ffffff; }\n    ._2g2N0-7_3_0:hover:before {\n      background-color: #808080;\n      border-radius: 50%; }\n  ._3TrT9-7_3_0 {\n    font-size: 16px;\n    min-width: 16px; }\n  ._157DG-7_3_0 {\n    font-size: 24px;\n    min-width: 24px; }\n  ._3UApg-7_3_0 {\n    font-size: 26px;\n    min-width: 26px; }\n", ""]);

// Exports
exports.locals = {
	"core-icon": "_1FgAl-7_3_0",
	"core-icon--clickable": "QtZLT-7_3_0",
	"core-icon--hover-fill": "_3Hw5E-7_3_0",
	"core-icon--hover-circle": "_2g2N0-7_3_0",
	"core-icon--sm": "_3TrT9-7_3_0",
	"core-icon--md": "_157DG-7_3_0",
	"core-icon--lg": "_3UApg-7_3_0"
};